import cookie from 'react-cookies';
import config from 'util/config';
import { map, isEmpty, join, replace, rangeRight, filter, isArray } from 'lodash';
import React from 'react';
import Moment from 'moment';
import { Link } from 'react-router-dom';
import { Col, message, Icon } from 'antd';

/**
 * getUserInfo
 *
 * @param {*} data
 * @returns
 */
export const getUserInfo = (data) => {
  let datas = data.authUser ? data.authUser.user : [];
  return datas;
}

/**
 * getCookieValue: Lấy cookie
 *
 * @param {*} name
 * @returns
 */
export const getCookieValue = (name) => {
  return cookie.load(name);
};

/**
 * setCookieValue: Gán cookie
 *
 * @param {*} name
 * @param {*} value
 * @returns
 */
export const setCookieValue = (name, value) => {
  return cookie.save(name, value);
};

/**
 * removeCookieValue: Xoá cookie value
 *
 * @param {*} name
 * @returns
 */
export const removeCookieValue = name => {
  return cookie.remove(name, { path: '/' });
}

/**
 * Lưu dữ liệu vào localStorage
 *
 * @param {*} key
 * @param {*} value
 * @returns
 */
export const setLocalStorage = (key, value) => {
  return localStorage.setItem(key, JSON.stringify(value));
}

/**
 * Lấy dữ liệu từ localStorage
 *
 * @param {*} key
 * @returns
 */
export const getLocalStorage = (key) => {
  return JSON.parse(localStorage.getItem(key));
}

/**
 * Xoá dữ liệu từ localStorage theo key
 *
 * @param {*} key
 * @returns
 */
export const removeLocalStorage = (key) => {
  return localStorage.getItem(key);
}

/**
 * Xoá hết dữ liệu trong localStorage
 *
 * @returns
 */
export const removeAllLocalStorage = () => {
  return localStorage.clear();
}

/**
 * logOut: Đăng xuất
 */
export const logOut = async () => {
  await removeCookieValue('accessTokensct');
  await removeCookieValue('currentMenuTop');
  await removeCookieValue('userId');
  // await removeCookieValue('userInfo');
  await removeCookieValue('defaultUrlsct');
  // await removeCookieValue('refresh');
  await removeAllLocalStorage();

  if (!getCookieValue('accessTokensct')) {
    window.location.href = await config.API_URL + "/saml/logout?url=" + window.location.protocol + '//' + window.location.host + window.location.hash;
  }
}

/**
 * reDataForTable: Dùng cho phân trang
 *
 * @param {*} data
 * @param {*} activePage
 * @param {*} pageSize
 */
export const reDataForTable = (data, activePage = 1, pageSize = 5000) => map(data, (item, index) => {
  return { key: activePage === 1 ? index + 1 : index + ((activePage - 1) * pageSize) + 1, ...item };
});

/**
 * reDataSelectedTable: Dành cho bảng có phần select
 * Cần phải thay key mặc định bằng id mới có thể gọi select mặc định
 * @param {*} data
 */
export const reDataSelectedTable = (data) => map(data, (item, index) => {
  item = { key: item.id, ...item };
  return item;
});

/**
 * StringValueReturn : Hàm xử lý dữ liệu trên bảng (Row expand)
 *
 * @export
 * @param {*} props
 * @returns
 */
export function StringValueReturn(props) {
  const { size, type, value, text, fieldName } = props;
  let valueTmp;
  if (type === 'text') {
    valueTmp = value ? value : '';
  } else if (type === 'date') {
    valueTmp = '';
    if (value) {
      valueTmp = Moment(value).format("DD/MM/YYYY");
    } else if (value !== 0) {
      valueTmp = Moment(value).format("DD/MM/YYYY");
    } else {
      valueTmp = '';
    }
  } else if (type === 'loaiDoanhNghiep') {
    valueTmp = '';
    if (value === 'hd') {
      valueTmp = 'Hoạt động';
    } else if (value === 'tn') {
      valueTmp = 'Ngừng hoạt động';
    } else {
      valueTmp = 'Đã chấm dứt hoạt động';
    }
  } else if (type === 'object') {
    valueTmp = value ? value[fieldName] : '';
  } else if (type === 'file') {
    valueTmp = value ? <Link to={{ pathname: `/custom-views/view-pdf`, state: { pdfUrl: value } }}>Xem nội dung</Link> : '';
  } else if (type === 'html') {
    valueTmp = value ? <Link to={{ pathname: `/custom-views/view-html`, state: { htmlValue: value } }}>Xem nội dung</Link> : '';
  } else if (type === 'boolean') {
    valueTmp = value ? 'Có' : 'Không';
  } else if (type === 'ccn') {
    valueTmp = value ? 'Trong cụm công nghiệp' : 'Ngoài cụm công nghiệp';
  } else if (type === 'linhvuc') {
    valueTmp = value ? 'Rượu' : 'Thuốc lá';
  } else if (type === 'gender') {
    valueTmp = value ? 'Nam' : 'Nữ';
  } else if (type === 'currency') {
    valueTmp = value ? formatNumber(value) : 0;
  } else if (type === 'VND') {
    valueTmp = value ? formatNumber(value) + ' (Đồng)' : 0;
  } else if (type === 'TrieuVND') {
    valueTmp = value ? formatNumber(value) + ' (Triệu đồng)' : 0;
  } else if (type === 'TyVND') {
    valueTmp = value ? formatNumber(value) + ' (Tỷ đồng)' : 0;
  } else if (type === 'HA') {
    valueTmp = value ? formatNumber(value) + ' (Hecta)' : 0;
  } else if (type === 'Tan') {
    valueTmp = value ? formatNumber(value) + ' (Tấn/năm)' : 0;
  } else if (type === 'lit') {
    valueTmp = value ? formatNumber(value) + ' (Lít)' : 0;
  } else if (type === 'km') {
    valueTmp = value ? formatNumber(value) + ' (km)' : 0;
  } else if (type === 'kV') {
    valueTmp = value ? value + ' (kV)' : 0;
  } else if (type === 'MW') {
    valueTmp = value ? value + ' (MW)' : 0;
  } else if (type === 'MVA') {
    valueTmp = value ? value + ' (MVA)' : 0;
  } else if (type === 'm2') {
    valueTmp = value ? value + ' (m2)' : 0;
  } else if (type === 'phantram') {
    valueTmp = value ? value + ' (%)' : 0;
  } else if (type === 'array') {
    const newArr = map(value, value => value[fieldName]);
    valueTmp = join(newArr, ', ');
  } else if (type === 'cai') {
    valueTmp = value ? formatNumber(value) + ' (Cái)' : 0;
  } else if (type === 'qua') {
    valueTmp = value ? formatNumber(value) + ' (Quả)' : 0;
  } else if (type === 'kg') {
    valueTmp = value ? formatNumber(value) + ' (Kg)' : 0;
  } else if (type === 'met') {
    valueTmp = value ? formatNumber(value) + ' (Mét)' : 0;
  } else if (type === 'number') {
    valueTmp = value ? value : 0;
  }
  if (!isEmpty(valueTmp) || valueTmp) {
    return (
      <Col span={8} md={size} xs={24} style={{ paddingBottom: 8 }}>
        <b>{text}</b>: {valueTmp}
      </Col>
    )
  } else {
    return null;
  }
}

/**
 * numberLocalConvert: chuyển đổi đơn vị số bản địa
 *
 * @param {*} value
 * @returns
 */
export const numberLocalConvert = (value) => {
  if (value) return value.toLocaleString();
}

/**
 * convertPhoneNumber: Hàm convert số điện thoại *
 * @param {*} e
 * @returns
 */
export const convertPhoneNumber = (e) => {
  if (e) {
    let value = e;
    value = value.replace(/[ .,]/g, "");
    let valueNumber;
    if (value && value.length === 10) {
      valueNumber = value.toString().match(/\b(?=(\d{4})+(\d{3})+(\d{3}))/);
      valueNumber.shift();
      valueNumber = valueNumber.join('.');
    }
    else if (value && value.length === 11) {
      valueNumber = value.toString().match(/\b(?=(\d{5})+(\d{3})+(\d{3}))/);
      valueNumber.shift();
      valueNumber = valueNumber.join('.');
    } else {
      value = e;
    }
    return valueNumber;
  }
  return e;
}
/**
 * Xoá tất cả dấu "," trong string
 *
 * @param {*} value
 * @returns
 */
export const removeAllComma = (value) => {
  let valueTmp = value.toString();
  valueTmp = replace(valueTmp, new RegExp(",", "g"), "");
  return valueTmp;
}

// Pattern : validate số trong string (ví dụ : số điện thoại...)
export const onlyAcceptNumberInString = '^\\S[0-9 ~!@#$%^&*()_+-=|\\/]+\\S$';

/**
 * StringValueReturn : Hàm xử lý xuât excel dữ liệu trên bảng
 *
 * @export
 * @param {*} classId
 * @param {*} docName
 * @returns
 */
export const handleExportExcelFunc = (classId, docName) => {
  let dataTime = Moment(new Date()).format("DD_MM_YYYY_HH_ss");
  setTimeout(function () {
    const table = document.getElementById(classId).innerHTML;
    const template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta charset="UTF-8" /><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>' + table + '</table></body></html>';
    const myBlob = new Blob([template], {
      type: 'application/vnd.ms-excel;charset=utf-8,'
    });
    const url = window.URL.createObjectURL(myBlob);
    const a = document.createElement("a");
    document.body.appendChild(a);
    a.href = url;
    a.download = `${docName}_${dataTime}.xls`;
    a.click();
    setTimeout(function () {
      window.URL.revokeObjectURL(url);
    }, 0);
  }, 1000);
}

/**
 * Hàm xuất MS Word
 *
 * @param {*} elementId
 * @param {string} [docName='']
 */
export const handleExportWordFunc = (elementId, docName = '') => {
  const preHtml = "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Export HTML To Doc</title></head><body>";
  const postHtml = "</body></html>";
  if (document.getElementById(elementId)) {
    const html = preHtml + document.getElementById(elementId).innerHTML + postHtml;
    const blob = new Blob(['\ufeff', html], {
      type: 'application/msword'
    });
    // Specify link url
    const url = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(html);
    // Specify file name
    docName = docName ? docName + '.doc' : 'document.doc';
    // Create download link element
    const downloadLink = document.createElement("a");
    document.body.appendChild(downloadLink);
    if (navigator.msSaveOrOpenBlob) {
      navigator.msSaveOrOpenBlob(blob, docName);
    } else {
      // Create a link to the file
      downloadLink.href = url;
      // Setting the file name
      downloadLink.download = docName;
      //triggering the function
      downloadLink.click();
    }
    document.body.removeChild(downloadLink);
  }
}

/**
 * Trả về ngày tháng long - date 'DD/MM/YYYY'
  @param {} value
 */
export const longToDate = (value) => {
  if (value === 0) {
    return '';
  } else if (value === null) {
    return '';
  } else if (value === undefined) {
    return '';
  } else {
    return Moment(value).format("DD/MM/YYYY");
  }
}

/**
 * Trả về ngày tháng trong khoảng ngày từ ngày 1-1 năm hiện tại tới 23:59:59 ngày hiện tại
 *
 * @param {*} status
 * @returns
 */
export const getDateRangerInTheCurrentYear = (status) => {
  let dateTmp = new Date();
  let fullYear = dateTmp.getFullYear();
  let month = '01';
  let date = '01';
  let hour = '00:00:00';
  if (status === 'denNgay') {
    month = dateTmp.getMonth() + 1;
    month = month.length === 1 ? `0${month}` : month;
    date = dateTmp.getDate();
    hour = '23:59:59';
    dateTmp = `${date}-${month}-${fullYear} ${hour}`;
  } else {
    dateTmp = `${date}-${month}-${fullYear} ${hour}`;
  }
  return dateTmp;
}

/**
 * Trả về ngày tháng trong khoảng ngày từ ngày (theo quy định) đến ngày hiện tại
 * Đối với thành phần này là trừ bao nhiêu ngày, tháng, năm
 *
 * @param {*} status - tuNgay, denNgay
 * @param {*} type - theoNgay, theoThang, theoNam
 * @param {*} data - trừ bao nhiêu
 * @returns
 */
export const getDateRangerHandle = (status, type = '', data = '') => {
  let dateTmp = new Date();
  let fullYear = dateTmp.getFullYear();
  if (status === 'denNgay') {
    dateTmp.setHours(23);
    dateTmp.setMinutes(59);
    dateTmp.setSeconds(59);
    dateTmp = Moment(dateTmp).format("DD/MM/YYYY HH:mm:ss");
  } else {
    if (type === 'theoNgay') {
      dateTmp.setDate(dateTmp.getDate() - data);
      dateTmp = Moment(dateTmp).format("DD/MM/YYYY HH:mm:ss");
    }
    if (type === 'theoThang') {
      dateTmp.setMonth(dateTmp.getMonth() - data);
      dateTmp = Moment(dateTmp).format("DD/MM/YYYY HH:mm:ss");
    }
    if (type === 'theoNam') {
      dateTmp.setFullYear(fullYear - data);
    }
  }
  return dateTmp;
}

/**
 * addAllValue : hàm get all value ( ví dụ : xã phường )
 * @param {*} array
 * @param {string} [type='diaPhuong']
 * @returns
 */
export const addAllValue = (array, type = 'diaPhuong', object) => {
  if (type === 'diaPhuong') {
    return [{ id: 0, ma: '', ten: '---Tất cả---' }, ...array];
  }
  if (type === 'custom') {
    return [object, ...array];
  }
}
/**
 * Tạo mảng năm dựa theo số đầu vào
 * Năm sẽ dựa từ năm hiện tại trừ đi
 * @param {*} number
 * @returns
 */
export const yearArrByRange = (number) => {
  const currentYear = new Date().getFullYear();
  return rangeRight(currentYear + 1, (currentYear - number));
}

/**
 * Hàm lây năm hiện tại và giá trị nhập vào là số lượng năm tiếp theo
 *
 * @param {*} numberOfYears
 * @returns
 */
export const generatorYear = (numberOfYears) => {
  let yearArr = [];
  let currentYear = Moment().year();
  for (let i = currentYear; i <= currentYear + numberOfYears - 1; i++) {
    yearArr.push({ value: i, name: i });
  }
  return yearArr;
}
/**
 * hàm lấy năm hiện tại là ở giữa giá trị nhập vào
 *
 * @param {*} numberOfYears
 * @returns
 */
export const generatorYearBetween5Years = (numberOfYears) => {
  let currentYear = Moment().year();
  let numberIncrement = Math.ceil(numberOfYears / 2);
  //
  let giam = [];
  for (let i = currentYear; i <= numberIncrement + currentYear; i--) {
    giam.push({ value: i, name: i });
  }

  let tang = [];
  for (let i = currentYear; i <= currentYear - numberIncrement; i++) {
    tang.push({ value: i, name: i });
  }
  let data = [...giam, ...tang];
  return data;
}
/**
 * Hàm lấy năm hiện tại và giá trị nhập vào là số lượng năm phía sau ( ví dụ: 2020, numberOfYears=5, thì sẽ lấy từ 2015->2020 )
 *
 * @param {*} numberOfYears
 * @returns
 */
export const generatorYearLast = (numberOfYears) => {
  let yearArr = [];
  let currentYear = Moment().year();
  yearArr.push({ value: currentYear + 1, name: currentYear + 1 });
  for (let i = currentYear; i >= currentYear - numberOfYears + 1; i--) {
    yearArr.push({ value: i, name: i });
  }
  return yearArr;
}

/**
 * Chuyển văn bản có dấu sang không dấu
 *
 * @param {*} str
 * @returns Văn bản không dấu
 */
export const boDauTiengViet = (str) => {
  str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
  str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
  str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
  str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
  str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
  str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
  str = str.replace(/đ/g, "d");
  str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A");
  str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E");
  str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I");
  str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O");
  str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U");
  str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y");
  str = str.replace(/Đ/g, "D");
  return str;
}


export const getFileName = value => value.split('/').pop().split('#')[0].split('?')[0];
/**
 * Chuyển đổi ảnh sang dạng base64
 *
 * @param {*} img
 * @param {*} callback
 * @returns
 */
export const getBase64 = (img, callback) => {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  let dataR = reader.readAsDataURL(img);
  return dataR;
}

/**
 * Check file trước khi tải lên
 *
 * @param {*} file
 * @returns
 */
export const beforeUpload = (file) => {
  const isJPG = file.type === 'image/jpeg';
  if (!isJPG) {
    message.error('Bạn chỉ có thể upload JPG file!');
  }
  const isLt2M = file.size / 1024 / 1024 < 2;
  if (!isLt2M) {
    message.error('Ảnh phải nhỏ hơn 2MB!');
  }
  return isJPG && isLt2M;
}

/**
 * Lọc ra danh sách theo tài khoản cấp tỉnh hoặc huyện
 *
 * @param {*} users: Danh sách user đầu vào
 * @param {boolean} capTinh
 * @returns Danh sách tài khoản theo yêu cầu
 */
export const filterUserIsCapTinh = (currentUserId, users, capTinh) => {
  if (isArray(users) && !isEmpty(users)) {
    if (capTinh) {
      return filter(users, user => user.maHuyen === '' && user.id !== currentUserId);
    } else {
      return filter(users, user => user.maHuyen !== '' && user.id !== currentUserId);
    }
  } else {
    return [];
  }
}

/**
 * Lọc ra danh sách người dùng theo điều kiện có phải là thương nhân?
 *
 * @param {*} isThuongNhan
 * @param {*} users
 * @returns
 */
export const filterAsThuongNhan = (isThuongNhan, users) => {
  if (isThuongNhan) {
    return filter(users, user => user.isThuongNhan === true);
  } else {
    return filter(users, user => user.isThuongNhan !== true);
  }
}

/**
 *Get the datetime by format
  * @param {*} obj.value the datetime value
  * @param {string} obj.format the format which will be used to convert the value
  * @param {boolean} obj.isUTC if true, the value will be converted to UTC time (default use local time)
  * @param {boolean} obj.isString if true, the value will be returned as a string
  * @returns {moment} the moment instance
  * @memberof Helpers
  */

export const getDateTime = ({
  value = undefined,
  format = null,
  isUTC = false,
  isString = true
}) => {
  if (!value || !Moment(value).isValid()) {
    return undefined;
  }
  const newValue = isUTC ? Moment.utc(value) : Moment.utc(value).local();
  let result = newValue;
  if (isString && isEmpty(format)) {
    result = Moment(newValue).format();
  }
  if (isString && !isEmpty(format)) {
    result = Moment(newValue).format(format);
  }
  if (!isString && isEmpty(format)) {
    result = Moment(Moment(newValue).format());
  }
  if (!isString && !isEmpty(format)) {
    result = Moment(Moment(newValue).format(format), format);
  }
  return result;
}

/**
 * Check file trước khi tải lên ko quá size MB
 * @param {number} limitSize
 * @param {*} file
 * @returns
 */
export const beforeUploadLimit = (limitSize, file) => {
  const isName = boDauTiengViet(file.name);
  const isFileTrue = file.size / 1024 / 1024 < limitSize;
  if (!isFileTrue) {
    message.error(`Dung lượng tải lên phải nhỏ hơn ${limitSize}MB!`);
  }
  return isFileTrue && isName;
}

/**
 * renderTrangThai: hiển thị trạng thái báo cáo
 * @param {sring} value
 * @returns
 */
export const renderTrangThai = (value) => {
  var tt = value ? value : '';
  switch (tt) {
    case 'DONGY':
      return '<span style="color: green">Đồng ý</span>';
    case 'CHODUYET':
      return '<span style="color: blue">Chờ duyệt</span>';
    case 'KHONGDONGY':
      return '<span style="color: red">Không đồng ý</span>';
    default:
      return 'Mới tạo';
  }
}

/**
 * renderKyBaoCao: render kỳ báo cáo 6 tháng đầu, 6 tháng cuối, 12 tháng
 * @param {string} item
 * @returns
 */
export const renderKyBaoCao = (item) => {
  var tt = item ? item : '';
  switch (tt) {
    case '6thangdaunam':
      return '6 tháng đầu năm';
    case '6thangcuoinam':
      return '6 tháng cuối năm';
    case '12thang':
      return '12 tháng';
    default:
      return ''
  }
}

/**
 * renderKyBaoCaos: hiển thị kỳ báo cáo link
 * @param {string} cell // tên kỳ báo cáo
 * @param {string} url // link
 * @returns
 */
export const renderKyBaoCaos = (cell, url) => {
  return (
    <div>
      <Link
        title="Xem chi tiết"
        to={{
          pathname: `${url}/${'view'}/chi-tiet/`,
        }}
      >
        {cell}
      </Link>
    </div>
  );
}

/**
 * listKyBaoCao12: kỳ báo cáo theo tháng
 * @returns
 */
export const listKyBaoCao12Thang = [
  { key: '1', value: 'Tháng 1' },
  { key: '2', value: 'Tháng 2' },
  { key: '3', value: 'Tháng 3' },
  { key: '4', value: 'Tháng 4' },
  { key: '5', value: 'Tháng 5' },
  { key: '6', value: 'Tháng 6' },
  { key: '7', value: 'Tháng 7' },
  { key: '8', value: 'Tháng 8' },
  { key: '9', value: 'Tháng 9' },
  { key: '10', value: 'Tháng 10' },
  { key: '11', value: 'Tháng 11' },
  { key: '12', value: 'Tháng 12' },
]

/**
 * listKyBaoCao2ky: kỳ báo cáo 6 tháng, 12 tháng
 * @returns
 */
export const listKyBaoCao2ky = [
  { key: '6', value: '6 tháng' },
  { key: '12', value: '12 tháng' },
]

/**
 * listKyBaoCao2ky: kỳ báo cáo 6 tháng, 12 tháng
 * @returns
 */
export const listKyBaoCao1ky = [
  { key: '1thang', value: '1 tháng' },
  { key: '3thang', value: '3 tháng' },
  { key: '6thang', value: '6 tháng' },
  { key: '9thang', value: '9 tháng' },
  { key: '12thang', value: '12 tháng' },
]

/**
* formatNumber: format số
* @param {int} value
* @returns
*/
export const formatNumber = (value) => {
  if (value === null || value === undefined || value === '') {
    return ''
  }
  else {
    let valueTmp = value ? value.toString().replace(".", ",") : 0;
    return valueTmp.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.");
  }
}

/**
* formatNumberEx: format số excel
* @param {int} value
* @returns
*/
export const formatNumberEx = (value) => {
  if (value === null || value === undefined || value === '') {
    return ''
  }
  else {
    return value.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
  }
}

/**
 * convertStringToFloat: format số kiểu double
 *
 */
export const convertStringToFloat = (number) => {
  if (number) {
    return parseFloat(number);
  }
  return 0;
}

/**
 * scrollToElement : Hiệu ứng scroll
 */
export const scrollToElement = (refValue) => {
  refValue.scrollIntoView({ behavior: "smooth" });
};

/**
 * isCheck : hiển thị check trên table
 */
export const isCheck = (check) => {
  return (
    check === true ? <Icon type='check' /> : null
  )
};

/**
 * isCheckExcel : hiển thị check xuất excel
 */
export const isCheckExcel = (check) => {
  return (
    check === true ? <span>&#10003;</span> : null
  )
};
/**
 * isCheckExcel : danh sách cấp
 */
export const listCap = [
  { value: '', name: '---Tất cả---' },
  { value: 'TINH', name: 'Tỉnh' },
  { value: 'HUYEN', name: 'Huyện' },
]

 /**
 * renderKyHieu : hiển thị ký hiệu
 */
export const renderKyHieu = (kyHieu)=> {
  var kh = kyHieu ? kyHieu : '';
  switch (kh) {
    case 'capmoi':
      return 'Cấp mới';
    case 'caplai':
      return 'Cấp lại';
      case 'thuhoi':
      return 'Thu hồi';
    case 'capdieuchinh':
      return 'Cấp điều chỉnh';
    default:
      return ''
  }
}
